import {
  confirmResetPassword,
  confirmSignIn,
  confirmUserAttribute,
  resetPassword as initiateResetPassword,
  sendUserAttributeVerificationCode,
  signIn as amplifySignIn,
  SignInOutput,
} from 'aws-amplify/auth'

/**
 * Signs in
 * @param {string} username
 * @param {string} password
 * @returns {User} User entity
 */
export const signIn = (
  username: string,
  password: string,
): Promise<SignInOutput> => amplifySignIn({ username, password })

/**
 * Sends the code for reseting user's password
 * @param {string} username
 * @returns nothing
 */
export const resetPasswordSendCode = (
  username: string,
): ReturnType<typeof initiateResetPassword> =>
  initiateResetPassword({ username })

/**
 * Resets user's password
 * @param {string} username
 * @param {string} code
 * @param {string} password
 * @returns nothing
 */
export const resetPassword = (
  username: string,
  code: string,
  password: string,
): Promise<void> =>
  confirmResetPassword({
    username,
    confirmationCode: code,
    newPassword: password,
  })

/**
 * Sets up user password for the first time after signup
 * @param {SignInOutput} signInResult - The sign in output from Amplify
 * @param {string} newPassword
 * @returns nothing
 */
export const setUpPassword = async (
  signInResult: SignInOutput,
  newPassword: string,
): Promise<ReturnType<typeof confirmSignIn>> => {
  if (
    signInResult.nextStep.signInStep ===
    'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED'
  ) {
    return confirmSignIn({
      challengeResponse: newPassword,
    })
  }
  throw new Error(
    'User is not in correct Auth state. Please contact support@meetyogi.com',
  )
}

/**
 * Sends the code for verifying user's email
 * @returns nothing
 */
export const sendVerificationCode = (): ReturnType<
  typeof sendUserAttributeVerificationCode
> =>
  sendUserAttributeVerificationCode({
    userAttributeKey: 'email',
  })

/**
 * Verifies user's email
 * @param {string} code
 * @returns nothing
 */
export const verifyUser = (code: string): Promise<void> =>
  confirmUserAttribute({
    userAttributeKey: 'email',
    confirmationCode: code,
  })
